export default __webpack_public_path__ + "static/media/roboto-v20-latin-100italic.55acbd03.svg";